export default __webpack_public_path__ + "static/media/logo_HAiGrey.6f743b46.svg";